<template>
  <div class="card">
    <div class="border-0 card-header">
      <h3 class="mb-0">List Items</h3>
    </div>
    <el-table class="table-responsive table-flush"
              header-row-class-name="thead-light"
              :data="items">
      <el-table-column label="Item"
                       min-width="310px"
                       prop="name">
        <template v-slot="{row}">
          <div class="media align-items-center">
            <div class="media-body">
              <span class="font-weight-600 name mb-0 text-sm">{{ row.title }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Type" min-width="250px">
        <template v-slot="{row}">
          <template v-if="row.taxonomies && row.taxonomies.length > 0">{{ row.taxonomies[0].title }}</template>
          <template v-else-if="row.taxonomy">{{ row.taxonomy.title }}</template>
        </template>
      </el-table-column>
      <el-table-column min-width="180px">
        <template v-slot="{row}">
          <el-dropdown trigger="click" class="dropdown">
                    <span class="btn btn-sm btn-icon-only text-light">
                      <i class="fas fa-ellipsis-v mt-2"></i>
                    </span>
            <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
              <a class="dropdown-item" v-on:click="removeItem(row.id)">Remove Item from List</a>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <el-table-column label="Move" min-width="100px">
        <template v-slot="{row}">
          <i v-on:click="moveItem(row.id, 1)" class="move-arrow fa fa-arrow-down"/>
          <i v-on:click="moveItem(row.id, -1)" class="move-arrow fa fa-arrow-up"/>
        </template>
      </el-table-column>
    </el-table>

    <div class="card-footer py-4 d-flex justify-content-end">
      <!--<base-pagination v-model="currentPage" :total="50"></base-pagination>-->
    </div>
  </div>
</template>
<script>
import {Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'

export default {
  name: 'list-table',
  props: {
    items: [Array, Object],
    default: [],
    moveItem: Function,
    removeItem: Function
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      currentPage: 1
    };
  },
  created() {
  }
}
</script>
<style lang="scss" scoped>
.move-arrow {
  display: inline-block;
  margin: 0 5px;
  cursor: pointer;
}
</style>
